import { useState, useContext } from "react";
import { Form, Input, Button, Upload, Image, Typography, Card, Breadcrumb } from "antd";
import { UploadOutlined, FilePdfOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const { Title, Paragraph } = Typography;

export default function EditAnnouncement({ editData, onBack }) {
    const { authData, backUrl } = useContext(AuthContext);

    const [data, setData] = useState({
        announcement_file: null,
        content: editData?.content || "",
        title: editData?.title || "",
        status: editData?.status || "APPROVED",
    });

    // check if existing file is an image
    const isImageFile = (fileUrl) => {
        if (!fileUrl) return false;
        return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(fileUrl);
    };

    // ✅ correct handler for Upload
    const handleFileChange = ({ fileList }) => {
        if (fileList && fileList.length > 0) {
            setData({ ...data, announcement_file: fileList[0].originFileObj });
        } else {
            setData({ ...data, announcement_file: null });
        }
    };

    // Submit form
    const handleSubmit = async () => {
        try {
            const formData = new FormData();
            formData.append("title", data.title);
            formData.append("content", data.content);
            formData.append("status", data.status);

            if (data.announcement_file) {
                formData.append("announcement_file", data.announcement_file);
            }

            const res = await axios.put(
                `${backUrl}/api/hr/announcements/${editData.id}/`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${authData.access}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            toast.success("Announcement updated successfully!");
            console.log("Updated:", res.data);

        } catch (err) {
            console.error("Error updating announcement:", err);
            toast.error("Failed to update announcement. Please try again.");
        }
    };

    return (
        <div style={{ maxWidth: 700, margin: "0 auto", padding: "20px" }}>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

            {/* Breadcrumb */}
            <Breadcrumb
                style={{ marginBottom: 16 }}
                items={[
                    {
                        title: (
                            <span
                                style={{ cursor: "pointer", color: "#0e497b" }}
                                onClick={onBack}
                            >
                                <ArrowLeftOutlined /> Back
                            </span>
                        ),
                    },
                ]}
            />

            <Card
                style={{
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                }}
            >
                <Title level={4} style={{ textAlign: "center", marginBottom: 20, color: "#0e497b" }}>
                    Edit Announcement
                </Title>

                <Form layout="vertical" onFinish={handleSubmit}>
                    {/* Title */}
                    <Form.Item label="Title" required>
                        <Input
                            value={data.title}
                            onChange={(e) => setData({ ...data, title: e.target.value })}
                            placeholder="Enter announcement title"
                        />
                    </Form.Item>

                    {/* Content */}
                    <Form.Item label="Content" required>
                        <Input.TextArea
                            rows={4}
                            value={data.content}
                            onChange={(e) => setData({ ...data, content: e.target.value })}
                            placeholder="Enter announcement content"
                        />
                    </Form.Item>

                    {/* Existing File Preview */}
                    {editData?.announcement_file && (
                        <Form.Item label="Current File">
                            {isImageFile(editData.announcement_file) ? (
                                <Image
                                    src={editData.announcement_file}
                                    alt="Current Announcement"
                                    style={{ borderRadius: 8, maxHeight: 200 }}
                                />
                            ) : (
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "10px 16px",
                                        borderRadius: "8px",
                                        background: "#fff1f0",
                                        color: "#cf1322",
                                    }}
                                >
                                    <FilePdfOutlined style={{ fontSize: 28, marginRight: 8, color: "red" }} />
                                    <a
                                        href={editData.announcement_file}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "#cf1322" }}
                                    >
                                        View Current File
                                    </a>
                                </div>
                            )}
                        </Form.Item>
                    )}

                    {/* Replace / Upload File */}
                    <Form.Item label={editData?.announcement_file ? "Replace File" : "Upload File"}>
                        <Upload
                            beforeUpload={() => false} // prevent auto-upload
                            maxCount={1}
                            onChange={handleFileChange}
                            showUploadList={false} // hide default upload list
                        >
                            <Button icon={<UploadOutlined />}>
                                {editData?.announcement_file ? "Choose New File" : "Upload File"}
                            </Button>
                        </Upload>

                        {data.announcement_file && (
                            <Paragraph type="secondary" style={{ marginTop: 8 }}>
                                Selected: {data.announcement_file.name}
                            </Paragraph>
                        )}
                    </Form.Item>

                    {/* Submit */}
                    <Form.Item>
                        <center>
                            <Button
                                style={{ color: "white", backgroundColor: "#0e497b", width: "140px" }}
                                htmlType="submit"
                            >
                                Save Changes
                            </Button>
                        </center>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
}
